<script lang="ts">
  import type {Poem, User} from '../../types'
  import LoadMore from '../../shared/LoadMore.svelte'
  import {t} from '../../i18n'
  import ModalTemplate from '../../shared/ModalTemplate.svelte'
  import {modal} from '../../stores/modal'

  export let poem: Poem
  export let onSelect: (user: User) => void

  let search: string = ''
  let users: User[] = []

  function selected(user: User): boolean {
    return poem.authors.map(a => a.id).includes(user.id)
  }

  function selectUser(user: User): void {
    if (!selected(user)) {
      onSelect(user)
    }
    modal.close()
  }

  function onSearchEnter(e: KeyboardEvent) {
    if (e.key === 'Enter') {
      search = (e.target as HTMLInputElement).value
    }
  }
</script>

<ModalTemplate>
  <div class="modal-content">
    <input placeholder={t.users.find} onkeydown={onSearchEnter}/>

    <div class="grid four tc">
      {#each users as user}
        {#if user}
          <div class="grid__item cursor-pointer {selected(user) ? 'selected' : ''}"
               onclick={() => selectUser(user)}>
            <div class="follower__photo">
              <img src={user.avatar_big_thumgb}/>
            </div>
            <div class="follower__name">
              <a href={user.link}>{user.full_name}</a>
            </div>
          </div>
        {/if}
      {/each}
    </div>

    <LoadMore per={9} url="/users" {search} bind:items={users}/>
  </div>
</ModalTemplate>
